import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selectsubscriptionsListItems } from "../../../../../redux/subscriptions/selector";
import { subscriptions } from "../../../../../redux/subscriptions/action";


const Subscriptions = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
	const { header, footer, currency } = result
    const subscriptionsItems = useSelector(selectsubscriptionsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
  
          { field: 'Name', headerName: 'Name',searchField: 'Name', filter: true,
            filterType: 'text' },
          { field: 'Email', headerName: 'Email',searchField: 'Email', filter: true,
            filterType: 'text' },
          { field: 'PhoneNumber', headerName: 'PhoneNumber',searchField: 'PhoneNumber', filter: false},
          { field: 'Validity', headerName: 'Validity',searchField: 'Validity', filter: false },
          { field: 'OwnerName', headerName: 'Subscription',searchField: 'OwnerName', filter: false },
          { field: 'CreatedOnUtc', headerName: 'Start Date', isDateValueFormat: true },
          { field: 'ModifiedOnUtc', headerName: 'End Date', isDateValueFormat: true },
          
    
        ]);
      }

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(subscriptions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/list`,entity:'subscriptions',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          }}))
      }
    
      const handleSelect = (item: any, checked: any) => {
        console.log("Item", checked, item)
      }
    
      const handleSelectAll = (items: any[], checked: any) => {
        console.log("Items count", checked, items?.length)
        console.log('items', items)
      }

      const handleReloadData = () => {
        dispatch(subscriptions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/list`,entity:'subscriptions',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const fetchSubscriptions=()=>{
        dispatch(subscriptions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/list`,entity:'subscriptions',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
     
	useEffect(() => {
        createColumnDefs()
        fetchSubscriptions()
	}, [pageData,pageSize])
   

      const handleDelete=(data: any)=>{
        dispatch(subscriptions.delete({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/delete`,
          entity: 'subscriptions',
          jsonData: {
            Records: [
              {
             
                    Id: data?.Id
                }
              
            ]
          }
      })).then(() => {
        dispatch(subscriptions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/list`,entity:'subscriptions',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      });
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
            <title>Add Subscription</title>
            <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
          </svg>,
        // name: 'Add Product',
        callback: () => handleAdd(),
      },
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];

            const handleUpgradeSubscription = async (data: any) => {
        navigate(`/management/upgrade-subscription/${data.OwnerId}/${data.PrimaryTenantId}`)
  };
	return (
    <>
    {subscriptionsItems?.isLoading ?  <PageLoader />: 
		<Table e  enableFilter={true} IsUpgradeSubscription={true} handleUpgradeSubscription={handleUpgradeSubscription}
    filterTypeLists={filterTypes}
    onSearch={handleSearch}columnData={columnDefs} rowData={subscriptionsItems?.result?.items} setPageData={setPageData}onEdit={handleEdit}
    setPageSize={setPageSize}paginationData={subscriptionsItems?.result?.pagination} onDelete={handleDelete} additionButtons={additionButtons} headingName="DBaas Subscriptions"/>
     
  }
  </> 
	);
};

export default Subscriptions;


